import React from 'react';
import ReactDOM from 'react-dom';
import "core-js/es";
import 'core-js/features/url-search-params';
import "isomorphic-fetch";
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

//ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.hydrate(<App />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
console.log("About to register service worker");
serviceWorker.register();
